import { render } from "./organisation-opportunities.vue?vue&type=template&id=e2c17642&scoped=true"
import script from "./organisation-opportunities.vue?vue&type=script&lang=js"
export * from "./organisation-opportunities.vue?vue&type=script&lang=js"

import "./organisation-opportunities.vue?vue&type=style&index=0&id=e2c17642&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c17642"]])

export default __exports__